import React from 'react';
import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useConsent } from '../analytics/ConsentContext';
import { azureColors } from '../theme';

const ConsentBanner = () => {
  const { decided, acceptAnalytics, rejectAnalytics } = useConsent();

  if (decided) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        p: { xs: 1.5, sm: 2 },
        pointerEvents: 'none',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          pointerEvents: 'auto',
          maxWidth: 960,
          mx: 'auto',
          p: { xs: 2, sm: 2.5 },
          borderRadius: 1,
          borderTop: `3px solid ${azureColors.primary}`,
          backgroundColor: '#FFFFFF',
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, color: azureColors.text }}>
          Privacy & analytics consent
        </Typography>
        <Typography variant="body2" sx={{ color: azureColors.textSecondary, mb: 2, lineHeight: 1.6 }}>
          We use optional analytics cookies / local storage to understand visits (pages viewed, approximate
          location from IP, device/browser details, referrer). No tracking runs until you choose. Read the{' '}
          <Link component={RouterLink} to="/privacy" underline="hover">
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link component={RouterLink} to="/cookies" underline="hover">
            Cookie Policy
          </Link>
          .
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'flex-end' }}>
          <Button variant="outlined" color="inherit" onClick={rejectAnalytics}>
            Reject analytics
          </Button>
          <Button variant="contained" onClick={acceptAnalytics}>
            Accept analytics
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ConsentBanner;
